<template>
  <v-container grid-list-md text-xs-center id="v-step-2">
    <v-dialog v-model="confirmDelete" max-width="590">
      <v-card style="margin: 0 !important">
        <v-card-title class="headline">
          Êtes-vous sûr de vouloir supprimer cette activité ?
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" text @click="confirmDelete = false">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn color="error" text @click="confirmDeleteActivity">{{
            $t("delete")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-spacer></v-spacer>
    <v-container v-if="!isDraft">
      <v-row>
        <!-- <v-col cols="6">
             <v-text-field
               solo-inverted
               flat
               hide-details
               label="Search"
               v-model="queryString"
               prepend-inner-icon="mdi-magnify"
               v-on:keyup.enter="
                 searchActivities(queryString, model, fonctionFilter, ageFilter)
               "
             ></v-text-field>
          </v-col>-->

        <v-col>
          <v-combobox
            dense
            single-line
            prepend-inner-icon="mdi-filter-variant"
            v-model="fonctionFilter"
            :items="items"
            small-chips
            multiple
            item-text="name"
            item-value="name"
            :search-input.sync="search"
            label="Fonction cognitive"
            solo
            background-color="#f7f6fb"
            flat
            @change="
              searchActivities(
                queryString,
                model,
                fonctionFilter,
                ageFilter,
                gradeFilter
              )
            "
          >
          </v-combobox>
        </v-col>
        <v-col>
          <v-combobox
            dense
            single-line
            clearable
            prepend-inner-icon="mdi-filter-variant"
            v-model="ageFilter"
            :items="itemsAgeFilter"
            label="Tranche d'âge"
            small-chips
            solo
            background-color="#f7f6fb"
            flat
            @change="
              searchActivities(
                queryString,
                model,
                fonctionFilter,
                ageFilter,
                gradeFilter
              )
            "
          >
          </v-combobox>
        </v-col>
        <v-col>
          <v-combobox
            dense
            single-line
            clearable
            prepend-inner-icon="mdi-filter-variant"
            v-model="gradeFilter"
            item-text="libelle"
            item-value="value"
            :items="itemsGradeFilter"
            label="Niveaux de preuves"
            small-chips
            solo
            background-color="#f7f6fb"
            flat
            @change="
              searchActivities(
                queryString,
                model,
                fonctionFilter,
                ageFilter,
                gradeFilter
              )
            "
          >
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-avatar>
                  <div class="content">
                    <v-btn
                      v-if="data.item.value === 'A'"
                      fab
                      style="background-color: #63b2ee"
                    >
                      <v-icon style="color:gold;">
                        mdi-check-decagram
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="data.item.value === 'B'"
                      fab
                      style="background-color: #63b2ee"
                    >
                      <v-icon style="color:silver;">
                        mdi-check-decagram
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="data.item.value === 'C'"
                      fab
                      style="background-color: #63b2ee"
                    >
                      <v-icon style="color:saddlebrown;">
                        mdi-check-decagram
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="data.item.value === 'AE'"
                      fab
                      style="background-color: #63b2ee"
                    >
                      <v-icon style="color:white;">
                        mdi-check-decagram
                      </v-icon>
                    </v-btn>
                  </div>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.libelle"
                  ></v-list-item-title>
                  <!--<v-list-item-subtitle v-html="'Grade ' + data.item.value"></v-list-item-subtitle>-->
                </v-list-item-content>
              </template>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <hr />
      <v-spacer></v-spacer>
    </v-container>
    <v-row class="mt-2">
      <v-col
        cols="12"
        sm="6"
        lg="4"
        v-for="activity of activities"
        :key="activity.id"
      >
        <v-hover v-slot:default="{ hover }" open-delay="50" close-delay="50">
          <div>
            <v-card
              flat
              :color="hover ? 'white' : 'transparent'"
              :elevation="hover ? 12 : 0"
              hover
              style="border-radius: 16px"
            >
              <div @click="goToActivity(activity.id)">
                <v-img
                  :lazy-src="noImage"
                  :src="activity.mainMedia ? activity.mainMedia : noImage"
                  :aspect-ratio="16 / 9"
                  gradient="to top, rgba(25,32,72,.4), rgba(25,32,72,.0)"
                  height="200px"
                  class="elevation-2"
                  style="border-radius: 16px"
                >
                  <v-card-text align="right">
                    <v-avatar color="primary" size="36">
                      <v-icon
                        v-if="activity.classification === 'A'"
                        class="text-right outlined"
                        style="color:gold;"
                      >
                        mdi-check-decagram
                      </v-icon>
                      <v-icon
                        v-if="activity.classification === 'B'"
                        class="text-right outlined"
                        style="color:silver;"
                      >
                        mdi-check-decagram
                      </v-icon>
                      <v-icon
                        v-if="activity.classification === 'C'"
                        class="text-right outlined"
                        style="color:saddlebrown;"
                      >
                        mdi-check-decagram
                      </v-icon>
                      <v-icon
                        v-if="
                          activity.classification === 'AE' ||
                            !activity.classification
                        "
                        class="text-right outlined"
                        style="color:white !important;"
                      >
                        mdi-check-decagram
                      </v-icon>
                    </v-avatar>
                  </v-card-text>
                </v-img>
                <v-card-text>
                  <div
                    v-if="activity.fonctionsCognitives"
                    style="white-space:nowrap;overflow-x:scroll;overflow-y: hidden;height:43px;"
                  >
                    <v-chip
                      small
                      v-for="fonctionCognitive of activity.fonctionsCognitives"
                      :key="fonctionCognitive"
                      class="ml-1"
                      style="display: inline-block;vertical-align: middle;"
                    >
                      {{ fonctionCognitive }}
                    </v-chip>
                  </div>
                  <div class="text-h5 font-weight-bold primary--text">
                    <p v-clampy="2" style="min-height: 30px">
                      {{ activity.titre }}
                    </p>
                  </div>
                  <div class="text-body-1">
                    <p
                      class="card-desc d-inline-flex font-weight-thin font-weight-light ml-2"
                      v-clampy="2"
                      style="min-height: 45px"
                    >
                      {{ activity.description }}
                    </p>
                  </div>
                  <div class="d-flex align-center">
                    <div class="pl-2" v-if="!isDraft">
                      {{ activity.userName }} ·
                      {{
                        new Date(activity.createdOn.seconds * 1000) | formatDate
                      }}
                    </div>
                  </div>
                </v-card-text>
              </div>
              <v-card-actions>
                <v-row class="pb-5">
                  <v-col align="left" cols="12">
                    <span
                      v-if="activity.age"
                      class="caption ml-2 grey--text font-weight-bold"
                      ><v-chip class="elevation-2" small>{{
                        activity.age
                      }}</v-chip></span
                    ><span>
                      <v-chip
                        v-if="activity.difficulte"
                        small
                        class="ma-2 elevation-2"
                        :color="
                          activity.difficulte === 'Facile'
                            ? 'green'
                            : activity.difficulte === 'Moyenne'
                            ? 'orange'
                            : 'red'
                        "
                        text-color="white"
                      >
                        {{ activity.difficulte }}
                      </v-chip>
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col align="right" cols="12">
                    <span
                      v-if="activity.difficulte"
                      class="text-right difficulte mr-2"
                    >
                      <span v-if="!isDraft">
                        <v-icon>mdi-comment-multiple-outline</v-icon>
                        {{ activity.comments }}
                      </span>
                      <span v-if="!isDraft">
                        <ToggleHeart
                          :id="activity.id"
                          :favorited="
                            user.data && user.data.likes.includes(activity.id)
                          "
                        ></ToggleHeart>
                        {{ activity.likes }}
                      </span>
                      <!--<span v-if="!isDraft">
                        <v-icon
                          v-if="
                            user.data && !user.data.fav.includes(activity.id)
                          "
                          @click="favThis(activity.id)"
                          >mdi-star-outline</v-icon
                        >
                        <v-icon
                          v-if="
                            user.data && user.data.fav.includes(activity.id)
                          "
                          @click="unfavThis(activity.id)"
                          style="color:gold"
                          >mdi-star</v-icon
                        >
                      </span>-->
                      <span class="text-right difficulte mr-0" v-if="isDraft">
                        <v-icon
                          class="delete-icon"
                          color="red"
                          @click="deleteActivity(activity.id)"
                          >mdi-delete</v-icon
                        >
                      </span>
                    </span>
                    <span
                      class="text-right difficulte mr-0"
                      v-if="isDraft && !activity.difficulte"
                    >
                      <v-icon
                        class="delete-icon"
                        color="red"
                        @click="deleteActivity(activity.id)"
                        >mdi-delete</v-icon
                      >
                    </span>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "../../router";
import clampy from "@clampy-js/vue-clampy";
import ToggleHeart from "@/components/Like/ToggleHeart";
const firebase = require("../../../firebase.config.js");

export default {
  name: "ActivitiesGrid",
  components: { ToggleHeart },
  props: {
    activities: { type: Array },
    isDraft: { type: Boolean }
  },
  directives: { clampy, ToggleHeart },
  computed: {
    ...mapGetters({
      user: "user/getUser"
    })
  },
  async created() {},
  methods: {
    ...mapActions({
      likeThis: "activities/likeThis",
      favThis: "activities/favThis",
      unfavThis: "activities/unfavThis",
      unlikeThis: "activities/unlikeThis",
      fetchDraft: "activities/fetchDraft",
      getActivitiesByFilters: "activities/getActivitiesByFilters",
      delete: "activities/deleteActivity"
    }),
    deleteActivity(id) {
      this.confirmDelete = true;
      this.activityToDelete = id;
    },
    confirmDeleteActivity() {
      this.confirmDelete = false;
      if (this.activityToDelete) {
        this.delete(this.activityToDelete);
      }
    },
    async goToActivity(id) {
      if (this.isDraft) {
        await this.fetchDraft(id);
        router.push({
          name: "CreateActivity",
          params: { isDraft: this.isDraft }
        });
      } else {
        router.push({ name: "ReadActivity", params: { id: id } });
      }
    },
    searchActivities(
      queryText,
      filter,
      fonctionFilter,
      ageFilter,
      gradeFilter
    ) {
      let fonctions = [];
      if (fonctionFilter.length > 0) {
        for (const fonction of fonctionFilter) {
          fonctions.push(fonction.name);
        }
      } else {
        fonctions = [];
      }

      if (!queryText && !fonctions) {
        filter = false;
      } else filter = true;
      this.getActivitiesByFilters({
        filter: filter,
        queryText: queryText,
        fonctionsCognitives: fonctions,
        age: ageFilter,
        grade: gradeFilter
      });
    }
  },
  data: () => ({
    overlay: false,
    activityToDelete: null,
    confirmDelete: false,
    noImage: require("@/assets/no_image.jpg"),
    medias: [],
    items: [
      { name: "Fonctions attentionnelles" },
      { name: "Mémoire à court terme et/ou de travail" },
      { name: "Mémoire à long terme (épisodique, sémantiques, procédurale)" },
      { name: "Fonctions exécutives (flexibilité, planification, inhibition, mise à jour)" },
      { name: "Gnosies" },
      { name: "Capacités visuo-spatiales et constructives" },
      { name: "Comportement(s)" },
      { name: "Vitesse de traitement" },
      { name: "Métacognition" },
      { name: "Cognition sociale" },
      { name: "Vie quotidienne" }
    ],
    itemsAgeFilter: ["Enfants", "Adolescents", "Adultes jeunes", "Adultes d'âge moyen", "Adultes âgés"],
    itemsGradeFilter: [
      { libelle: "Haut niveau de preuve", value: "A" },
      { libelle: "Niveau de preuve modéré", value: "B" },
      { libelle: "Faible niveau de preuve", value: "C" },
      { libelle: "Avis d'expert (Aucune preuve scientifique)", value: "AE" }
    ],
    model: "",
    fonctionFilter: "",
    ageFilter: "",
    gradeFilter: "",
    search: null,
    queryString: "",
    firebase: firebase
  }),
  watch: {
    hover: function(oldVal, newVal) {
      if (newVal) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "wait";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  -webkit-appearance: progress-bar;
  height: 9px;
}
::-webkit-scrollbar-thumb {
  border-radius: 50px;
  background-color: rgba(0, 0, 0, 0.3);
}

.delete-icon:hover {
  cursor: pointer;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dark-text {
  color: #333333;
}

.v-application .pa-3 {
  padding: 12px !important;
}
</style>
